import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class ComplainHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    getAllComplains(branchId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/complain/getAllComplains`, { params: { branchId: branchId } });
    }

    getComplainById(complainId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/complain/getComplainById`, { params: { complainId: complainId } });
    }

    newComplain(complains: any): Observable<any> {
        return this.http.post<any>(`${this.configurations.baseUrl}/api/complain/newComplain`, complains);
    }

    editComplain(complains: any): Observable<any> {
        return this.http.put<any>(`${this.configurations.baseUrl}/api/complain/editComplain`, complains);
    }

    deleteComplain(complainId: any): Observable<any> {
        return this.http.delete<any>(`${this.configurations.baseUrl}/api/complain/deleteComplain`, { params: { complainId: complainId } });
    }
}
